// src/modules/app-views/_apps/appmulti/coupons/pages/Init/components/tableColumns/expirationColumn.js
import dayjs from 'dayjs';
import translateX from 'utils/translateX';

function expirationColumn(buildColumnProps, options = {}) {
  const {
    key = 'expirationDate',
    title = 'expiration_date',
    dataIndex = 'expirationDate',
    width = 130,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    align: 'center',
    render: value => {
      if (!value) return <span className="text-muted">—</span>;
      return dayjs(value).format('L');
    },
  };
}

export default expirationColumn;
